import { useSuspenseQuery } from '@tanstack/react-query'
import { useRef } from 'react'

import { Authentication } from 'Common/auth/types'
import { getQueryClient } from 'Common/base/queryClient'
import queryKeys from 'Common/queryKeys/queryKeys'

export const useAuth = () => {
    const { data } = useSuspenseQuery<Authentication>({
        queryKey: [queryKeys.auth],
        queryFn: () => {
            throw new Error('Auth queryFn should never run')
        },
    })
    return data
}

export const useStableAuth = () => {
    const auth = useAuth()
    const key = JSON.stringify(auth.data?.opus_user?.access ?? null)
    const ref = useRef(auth)
    const prevKey = useRef(key)
    if (key !== prevKey.current) {
        prevKey.current = key
        ref.current = auth
    }
    return ref.current
}

export const getAuthFromCache = () =>
    getQueryClient().getQueryData<Authentication>([queryKeys.auth])
